import { render, staticRenderFns } from "./BlockListCta.vue?vue&type=template&id=c2de262c&"
import script from "./BlockListCta.vue?vue&type=script&lang=js&"
export * from "./BlockListCta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports